import { createClient } from "@sanity/client";

const client = createClient({
  projectId: 'l790oga7',
  dataset: 'production',
  apiVersion: '2025-04-04', // use the date when your schema was last updated
  useCdn: true, // `true` for faster response with cache (use `false` for fresh data)
});

export default client;
